import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import logoIcon from '@/assets/images/translatorLogo.svg';
import css from '../index.module.less';

interface ShareHeaderProps {
  theme: 'light' | 'dark';
  onToggleTheme: () => void;
  rightExtra?: ReactNode;
}

const SUBTITLE_HOME_URL = import.meta.env.VITE_FELO_SUBTITLE_HOME_URL || 'https://subtitle.felo.me';

export function ShareHeader({ theme, onToggleTheme, rightExtra }: ShareHeaderProps) {
  const { t } = useTranslation();

  const onClickLogo = () => {
    window.open(SUBTITLE_HOME_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className={css.pageTitle}>
      <button
        type="button"
        className={css.logoBtn}
        onClick={onClickLogo}
        aria-label="Felo Subtitles"
      >
        <img src={logoIcon} alt="Felo Logo" />
        <span>{t('menuSubtitles')}</span>
      </button>
      <div className={css.headerRightWrap}>
        {rightExtra}
        <button
          type="button"
          onClick={onToggleTheme}
          className={css.themeToggle}
          aria-label="Toggle theme"
        >
          {theme === 'light' ? (
            <svg viewBox="0 0 24 24" width="24" height="24" className={css.moonIcon}>
              <path
                fill="currentColor"
                d="M21.53 15.93c-.16-.27-.61-.69-1.73-.49a8.46 8.46 0 01-1.88.13 8.409 8.409 0 01-5.91-2.82 8.068 8.068 0 01-1.44-8.66c.44-1.01.13-1.54-.09-1.76s-.77-.55-1.83-.11a10.318 10.318 0 00-6.32 10.21 10.475 10.475 0 007.04 8.99 10 10 0 002.89.55c.16.01.32.02.48.02a10.5 10.5 0 008.47-4.27c.67-.93.49-1.519.32-1.79z"
              />
            </svg>
          ) : (
            <svg viewBox="0 0 24 24" width="24" height="24" className={css.sunIcon}>
              <path
                fill="currentColor"
                d="M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zM2 13h2c.55 0 1-.45 1-1s-.45-1-1-1H2c-.55 0-1 .45-1 1s.45 1 1 1zm18 0h2c.55 0 1-.45 1-1s-.45-1-1-1h-2c-.55 0-1 .45-1 1s.45 1 1 1zM11 2v2c0 .55.45 1 1 1s1-.45 1-1V2c0-.55-.45-1-1-1s-1 .45-1 1zm0 18v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1s-1 .45-1 1zM5.99 4.58a.996.996 0 00-1.41 0 .996.996 0 000 1.41l1.06 1.06c.39.39 1.03.39 1.41 0s.39-1.03 0-1.41L5.99 4.58zm12.37 12.37a.996.996 0 00-1.41 0 .996.996 0 000 1.41l1.06 1.06c.39.39 1.03.39 1.41 0a.996.996 0 000-1.41l-1.06-1.06zm1.06-10.96a.996.996 0 000-1.41.996.996 0 00-1.41 0l-1.06 1.06c-.39.39-.39 1.03 0 1.41s1.03.39 1.41 0l1.06-1.06zM7.05 18.36a.996.996 0 000-1.41.996.996 0 00-1.41 0l-1.06 1.06c-.39.39-.39 1.03 0 1.41s1.03.39 1.41 0l1.06-1.06z"
              />
            </svg>
          )}
        </button>
      </div>
    </div>
  );
}
